<template>
  <div>
    <el-image :src="require('@/assets/pictures/logo.jpg')"></el-image>
    <el-form
      ref="form"
      :model="form"
      label-position="label_position"
      label-width="80px"
      size="mini"
    >
      <el-form-item label="交易市场" prop="market">
        <el-select
          v-model="form.market"
          :placeholder="market_txt"
          style="width:160px;"
        >
          <el-option label="上海A股" value="上海A股"></el-option>
          <el-option
            label="深圳主板"
            value="深圳主板"
            :disabled="disable_by_level"
          ></el-option>
          <el-option label="上海B股" value="上海B股" disabled></el-option>
          <el-option label="深圳B股" value="深圳B股" disabled></el-option>
          <el-option label="三板" value="三板" disabled></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="股票模型" prop="model_types">
        <el-select
          v-model="form.model_types"
          multiple
          :placeholder="model_text"
          style="width:160px;"
        >
          <el-option label="加特利" value="Gartley"></el-option>
          <el-option
            label="蝴蝶"
            value="Butterfly"
            :disabled="disable_by_level"
          ></el-option>
          <el-option
            label="蝙蝠"
            value="Bat"
            :disabled="disable_by_level"
          ></el-option>
          <el-option
            label="螃蟹"
            value="Crab"
            :disabled="disable_by_level"
          ></el-option>
          <el-option
            label="鲨鱼"
            value="Shark"
            :disabled="disable_by_level"
          ></el-option>
          <el-option label="AB-CD" value="ABCD" disabled></el-option>
          <el-option label="三波段" value="3drives" disabled></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="结束日期" prop="date">
        <el-date-picker
          :picker-options="pickerOptions"
          type="date"
          default-value="form.date"
          placeholder="选择日期"
          v-model="form.date"
          value-format="yyyy-MM-dd"
          style="width:160px;"
        ></el-date-picker>
      </el-form-item>

      <el-form-item label="预示行情" prop="market_types">
        <el-checkbox-group v-model="form.market_types">
          <el-checkbox label="Bullish" name="type" checked
            >牛市行情</el-checkbox
          >
          <el-checkbox label="Bearish" name="type" checked
            >熊市行情</el-checkbox
          >
        </el-checkbox-group>
      </el-form-item>
      <el-form-item>
        <el-row class="el-row" type="flex" justify="space-around">
          <el-button type="primary" @click="onSubmit">搜索</el-button>
          <el-button @click="onCancel">取消</el-button>
        </el-row>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import bus from "@/assets/js/bus";

export default {
  name: "SearchForm",
  data() {
    return {
      form: {
        market: "上海A股",
        model_types: ["Gartley", "Butterfly", "Bat", "Crab", "Shark"],
        date: "",
        market_types: []
      },
      label_position: "left",
      //禁用选择未来日期
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      disable_by_level:
        window.sessionStorage.getItem("userlevel") == "1" ? false : true,
      market_txt:
        window.sessionStorage.getItem("userlevel") == "1"
          ? "请选择"
          : "升级会员可选所有板块",
      model_text:
        window.sessionStorage.getItem("userlevel") == "1"
          ? "请选择"
          : "升级会员可选所有模型"
    };
  },
  mounted() {
    const myDate = new Date();
    const year = myDate.getFullYear(); // 获取当前年份
    const month = myDate.getMonth() + 1; // 获取当前月份(0-11,0代表1月所以要加1);
    const day = myDate.getDate(); // 获取当前日（1-31）
    var mm = (Array(2).join("0") + month).slice(-2);
    var dd = (Array(2).join("0") + day).slice(-2);
    // 日期格式：20210520
    this.form.date = `${year}-${mm}-${dd}`;
  },
  methods: {
    onSubmit() {
      //validation
      if (this.form.market == "") {
        this.$alert("请选择股票交易市场");
        return;
      }

      if (this.form.model_types.length == 0) {
        this.$alert("请选择至少一个股票模型");
        return;
      }

      if (this.form.date == "") {
        this.$alert("请选择股票交易日");
        return;
      }

      if (this.form.market_types.length == 0) {
        this.$alert("请选择至少一个市场行情");
        return;
      }

      //change the total size of ModelPagination
      //getModelsUrl(this.form)
      this.$axios
        .post("/api/stock_model", this.form)
        .then(result => {
          if (result.data.stock_model == null) {
            this.$alert(
              "未发现模型数据，可能原因：所选日期非股票交易日，历史数据已被删除或者后台数据尚未生成。"
            );
          } else if (result.data.stock_model.length == 0) {
            this.$alert("根据当前参数，没有匹配到指定模型");
          } else {
            bus.$emit("stock_models", result.data.stock_model);
          }
        })
        .catch(err => {
          console.log("获取模型数据，解析失败！");
        });
    },
    onCancel() {
      //this.form = this.$$options.data.form;
      this.$refs["form"].resetFields();
    }
  }
};
</script>

<style>
/**站内信长单词强制换行 */
.message_box_alert {
  word-break: break-all !important;
}
</style>



// WEBPACK FOOTER //
// src/components/SearchForm.vue